import script from "./Payments.vue?vue&type=script&setup=true&lang=js"
export * from "./Payments.vue?vue&type=script&setup=true&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=aee5fc10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aee5fc10"]])

export default __exports__